/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedAdditionalWorkListAdmin } from './PaginatedAdditionalWorkListAdmin'
import {
  PaginatedAdditionalWorkListAdminFromJSON,
  PaginatedAdditionalWorkListAdminFromJSONTyped,
  PaginatedAdditionalWorkListAdminToJSON,
} from './PaginatedAdditionalWorkListAdmin'

/**
 *
 * @export
 * @interface EnvelopedServiceListAdditionalWorkListAdmin
 */
export interface EnvelopedServiceListAdditionalWorkListAdmin {
  /**
   *
   * @type {PaginatedAdditionalWorkListAdmin}
   * @memberof EnvelopedServiceListAdditionalWorkListAdmin
   */
  body: PaginatedAdditionalWorkListAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedServiceListAdditionalWorkListAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedServiceListAdditionalWorkListAdmin interface.
 */
export function instanceOfEnvelopedServiceListAdditionalWorkListAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedServiceListAdditionalWorkListAdminFromJSON(
  json: any,
): EnvelopedServiceListAdditionalWorkListAdmin {
  return EnvelopedServiceListAdditionalWorkListAdminFromJSONTyped(json, false)
}

export function EnvelopedServiceListAdditionalWorkListAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedServiceListAdditionalWorkListAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedAdditionalWorkListAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedServiceListAdditionalWorkListAdminToJSON(
  value?: EnvelopedServiceListAdditionalWorkListAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedAdditionalWorkListAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
